<template>
  <svg :class=[cls] aria-hidden="true">
    <use :xlink:href="'#icon-' + icon"></use>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    cls: String,
    icon: String
  }
}
</script>
